
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gEyYn7X1dl5IQ0OUSCYjFxiaFIKAMEF7ykOkiM1fVNiUMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexH5V_45gY_454zWjrouICLxGbBDYzIllqLMKlHLB83gdWfZYMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchpT8M4Y2i2QdAm3Jh6G3H71Qhy5Og9tdPr7HaE6LwRnoMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index84K_XxOkfboFYXmMKFmRP7BzT08LpOB6NQ_rA418NfoMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93ycNaoSOZGfvMrpDSYk25XPcuLAhqfllja12neHwXufwMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indextxHkJceK6ogzW9uuEp7mllTUQTmtk8W70zIrysktgEIMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_938L5raNYQzqisE2Pq0FlaVXsLM41rW_45H_4KHrog7AF3QMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexMr9j783vsdsDNS_45pzi_45kEQKx5xnD7Sdh5xVpvwPfchkMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93hDwAAaVQ9Ym1pB70ANxwplqKuK6H44YRQR29v5YKgjIMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexRgwQ_uTplQLNdUzJpLShNLQqNL2uz3RFF907j6VK66QMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexUd9tGvbwfwIIdpkoIYlgyeOQ6Sbrw9UUspamrSIpDKMMeta } from "/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indextxHkJceK6ogzW9uuEp7mllTUQTmtk8W70zIrysktgEIMeta || {},
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexMr9j783vsdsDNS_45pzi_45kEQKx5xnD7Sdh5xVpvwPfchkMeta || {},
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexRgwQ_uTplQLNdUzJpLShNLQqNL2uz3RFF907j6VK66QMeta || {},
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexUd9tGvbwfwIIdpkoIYlgyeOQ6Sbrw9UUspamrSIpDKMMeta || {},
    component: () => import("/codebuild/output/src2247744797/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]